/** Display label for penalty days; null/0 → "—" (warnings, amount-only). */
export function formatPenaltyDays(days) {
  if (days == null || days === "" || Number(days) === 0) return "—";
  const n = Number(days);
  if (!Number.isFinite(n)) return "—";
  if (n === 0.25) return "ربع يوم";
  if (n === 0.5) return "نص يوم";
  if (n === 1) return "يوم واحد";
  if (n === 2) return "يومان";
  return `${n} يوم`;
}

/**
 * Strip internal auto-penalty markers (ids / system prefixes) for UI copy.
 * Stored reason keeps the marker for idempotency; users never see it.
 */
export function humanizePenaltyReason(reason) {
  if (!reason) return "";
  return String(reason)
    .replace(/^AUTO_LATE:\s*/i, "")
    .replace(/^AUTO_ABSENCE:\s*/i, "")
    .replace(/^AUTO_EARLY_LEAVE:\s*/i, "")
    .replace(/^AUTO_APPROVAL_(?:DELAY|SKIP):\S+\s*[—–-]?\s*/i, "")
    .trim();
}

/** Same as humanizePenaltyReason, with "—" when empty. */
export function formatPenaltyReason(reason) {
  if (!reason) return "—";
  return humanizePenaltyReason(reason) || "—";
}
